import Grid from '@mui/material/Unstable_Grid2'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { Dayjs } from 'dayjs'
import { useTranslation } from 'react-i18next'

interface VipDateTimeRangeProps {
  startDate: Dayjs | null
  endDate: Dayjs | null
  mode: string
  handleInputChange: (inputName: string, value: any) => void
}

export function VipDateTimeRange({ startDate, endDate, handleInputChange, mode }: VipDateTimeRangeProps) {
  const { t } = useTranslation(['global'])

  return (
    <>
      <Grid xs={12} sm={6} md={6}>
        <DateTimePicker
          sx={{ width: '100%' }}
          label={t('start-date')}
          value={startDate}
          onChange={value => handleInputChange('startDate', value)}
        />
      </Grid>

      <Grid xs={12} sm={6} md={6}>
        <DateTimePicker
          sx={{ width: '100%' }}
          label={t('end-date')}
          value={endDate}
          onChange={value => handleInputChange('endDate', value)}
        />
      </Grid>
    </>
  )
}
